<template>
    <v-container fluid class="" style="margin-top: 20px">
        <v-card>
            <v-card color="primary">
                <v-card-title class="title-text"> Administración de Categorías </v-card-title>
            </v-card>
            <v-card-text>
                <div style="height: 50px;"></div>
                <v-container>
                    <v-row justify="center" class="mb-10">
                        <v-col cols="12" md="6">
                            <h1 class="new-category-text">Nueva Categoría</h1>
                            <v-form ref="formCat">
                                <v-text-field v-model="newCatName" placeholder="Nombre" outlined
                                    v-on:blur="newCatName = newCatName != null ? newCatName.trim() : null" :rules="rules">
                                </v-text-field>
                            </v-form>
                            <v-row class="px-3">
                                <v-spacer></v-spacer>
                                <v-btn class="px-5" color="primary" @click="addNewCategory()">
                                    Agregar
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <v-sheet elevation="10" rounded="xl">
                                <v-sheet class="pa-3 primary text-right" dark rounded="t-xl" style="min-height: 60px;">
                                    <v-btn class="ml-2" icon v-if="deleatingStatus" @click="cancelDelete()">
                                        <v-icon>mdi-cancel</v-icon>
                                    </v-btn>
                                    <v-btn class="ml-2" icon v-if="deleatingStatus" @click="saveDelete()">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                </v-sheet>
                                <div class="pa-4">
                                    <v-chip-group column>
                                        <v-chip v-for="(tag, index) in categoryItems" :key="index" close color="primary"
                                            @click:close="listDeleteCategory(index, tag)">
                                            {{ tag.categoria }}
                                        </v-chip>
                                    </v-chip-group>

                                </div>
                                <div class="pa-4" v-if="deleatingStatus">
                                    <v-divider></v-divider>
                                    <v-chip-group column>
                                        <v-chip v-for="(item, indx) in deleatedTags" :key="indx" color="red"
                                            text-color="white">
                                            {{ item.categoria }}
                                        </v-chip>
                                    </v-chip-group>
                                </div>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <div style="height: 100px;"></div>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import BlogService from "@/services/Blogs/Blogs.service.js";;
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
    },
    data() {
        return {
            newCatName: "",
            categoryItems: [],
            deletedCategoriesList: [],

            deleatingStatus: false,

            deleatedTags: [],

            rules: [
                v => !!v || 'Campo requerido',
                v => (v && v.length > 2) || 'Agregue más de 2 caracteres',
            ],
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async mounted() {
        this.obtenerCategorias();
    },
    methods: {
        async obtenerCategorias() {
            let response = await BlogService.ObtenerCategoriasTodas();
            this.categoryItems = response;
        },

        async listDeleteCategory(index, item) {
            this.deleatingStatus = true;
            this.deletedCategoriesList.push(item.clave);
            this.deleatedTags.push(item);
            this.categoryItems.splice(index, 1);
        },

        async cancelDelete() {
            this.deleatingStatus = false;
            this.deleatedTags = [];
            this.deletedCategoriesList = [];
            this.categoryItems = [];
            let response = await BlogService.ObtenerCategoriasTodas();
            this.categoryItems = response;
        },

        async saveDelete() {
            BlogService.BlogEliminarCategoria(JSON.stringify(this.deletedCategoriesList))
            this.deleatingStatus = false;
            this.deleatedTags = [];
            this.deletedCategoriesList = [];
        },

        async addNewCategory() {

            this.$refs.formCat.validate();
            const validation = this.$refs.formCat.validate();
            if (validation == true) {
                this.$swal({
                    title: "Guardando, espere un momento...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                let response = await BlogService.BlogAgregarCategoria(this.newCatName);
                if (response == true) {
                    this.newCatName = null;
                    this.$refs.formCat.reset();
                    await this.obtenerCategorias();
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Correcto",
                        text: "Los datos se guardaron correctamente",
                        showConfirmButton: true,
                        timer: 5000,
                    });
                } else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Oops...",
                        text: "Ha ocurrido un error inesperado intente nuevamente más tarde",
                        showConfirmButton: true,
                        timer: 5000,
                    });
                }
            }
        }


    },
};
</script>

<style scoped>
.title-text {
    font-family: "Poppins", sans-serif;
    font-size: 1.3rem !important;
    font-weight: 600 !important;
    color: white;
}

.new-category-text {
    font-family: "Poppins", sans-serif;
    font-weight: 800 !important;
    font-size: 1.6rem !important;
}
</style>